import { AllTranslationMap } from '../base/common/i18n.js';
import { en } from './lang/en.js';

export type TranslationMap = typeof en;

export const languages = ['en'];
export const defaultLanguage = 'en';

export const translations: AllTranslationMap<TranslationMap> = { en };
